import { FieldSettingsT } from 'routes/BudgetModule/config/types';
import {
    ColDef,
    ColGroupDef,
    ColumnMovedEvent,
    ColumnResizedEvent,
    ColumnRowGroupChangedEvent,
    ColumnVisibleEvent,
} from 'ag-grid-community';
import { OnGroupTracking } from 'helpers/trackerHelpers';

export const getColumnSettings = (
    colDef: ColDef,
    columnsSettings: FieldSettingsT[],
): FieldSettingsT | undefined =>
    columnsSettings.find((item) => item.field === colDef.field);

// -------- VISIBILITY --------
export const onColumnVisible =
    (updateSettings: (colDefs: ColDef[]) => void) =>
    (params: ColumnVisibleEvent) => {
        // Ignore hide from drag & drop in grouping section
        if (params.source !== 'toolPanelUi') return;
        const colDefs: ColDef[] = params.api.getColumnDefs() ?? [];
        updateSettings(colDefs);
    };

// -------- RESIZING --------
export const onColumnResized =
    (updateSettings: (colDefs: ColDef[]) => void) =>
    (params: ColumnResizedEvent) => {
        const colDefs: ColDef[] = params.api.getColumnDefs() ?? [];
        updateSettings(colDefs);
    };

// -------- GROUPING --------
export const onColumnRowGroupChanged =
    (
        updateSettings: (colDefs: ColDef[]) => void,
        trackGrouping: OnGroupTracking,
    ) =>
    (params: ColumnRowGroupChangedEvent) => {
        // Ignore hide from initial render (which doesn't occur all the time)
        // because otherwise a PATCH is made with the initial settings
        if (params.source !== 'toolPanelUi') return;

        const colDefs: ColDef[] = params.api.getColumnDefs() ?? [];

        // We make columns visible again after un-grouping them
        colDefs.forEach((colDef) => {
            if (colDef.rowGroup) {
                colDef.hide = false;
            }
        });

        updateSettings(colDefs);
        trackGrouping(params);
    };

// -------- ORDERING --------
export const onColumnMoved =
    (updateSettings: (colDefs: (ColDef | ColGroupDef)[] | undefined) => void) =>
    (params: ColumnMovedEvent) => {
        const colDefs = params.api.getColumnDefs();
        updateSettings(colDefs);
    };

// ------ EXPANDING ---------
export const onRowClicked = (params: FlowAnyObject): (() => void) =>
    params.node.setExpanded(!params.node.expanded);
